import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { AppService } from "../../core/services/app.service";
import { EventService } from "../../core/services/event.service";
import * as moment from "moment";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})

export class LocationService extends EventService {
    static SET_LOCATIONS_FILTER = 'set-filter-location';
    static LAZY_LOADING_LOCATIONS = 'lazy-loading-location';
    static CURRENT_LOCATION_TIME_START = moment();
    
    constructor(public http: HttpClient) {
        super()
    }

    public static locationAPI = AppService.getApiUrl() + '/api/locations/';

    createLocation(data) {
        return this.http.post(LocationService.locationAPI, data);
    }

    moveLocation(data) {
        return this.http.post(LocationService.locationAPI + 'moveLocation', data);
    }

    deleteById(id) {
        return this.http.delete(LocationService.locationAPI + id);
    }

    updateLocation(id, data) {
        return this.http.put(LocationService.locationAPI + id, data);
    }

    getLocationList(status, coordinates = null, skip = 0, limit = 100, groupData? : {
        id: number,
        ownerId: number,
        userId: number,
        ownerLocationFeature: boolean;
    }) {
        
        let params: any = {
            where : {
                and : [
                    {
                        status: status,
                    }
                ]
            },
            skip : skip,
            limit : limit,
        }
        
        if (groupData) {
            params.where.and.push({
                groupId : groupData.id
            })
            if (groupData.ownerLocationFeature) {
                params.where.and.push({
                    or: [
                        {
                            customerId : groupData.ownerId
                        }
                    ]
                })
                
                if (groupData.ownerId != groupData.userId) {
                    params.where.and[2].or.push({
                        customerId : groupData.userId
                    }) 
                }
            }
        } else {
            params.where.and.push({
                groupId : null
            })
        }
        
        if (coordinates) {
            params.coordinates = {
                lat: coordinates.lat,
                lng: coordinates.lng,
            }
            
        }
        
        params = encodeURIComponent(JSON.stringify(params));
        return this.http.get(LocationService.locationAPI + `?filter=${params}`);
    }
    
    getLocationByUser(status = null, skip = 0, limit = 20, customerId = null) {
        if (skip == 0) { //get the latest time
            LocationService.CURRENT_LOCATION_TIME_START = moment();
        }
        
        const filter: any = {
            where : {
                and : [
                    {
                        partnerId : {
                            neq : 99
                        },
                    },
                    {
                        partnerId : {
                            neq : 0
                        },
                    }
                ],
                customerId: customerId,
                groupId: null,
                createdDate: {
                    lt: LocationService.CURRENT_LOCATION_TIME_START
                }
            },
            skip : skip,
            limit : limit,
            order: 'id desc'
        }
        
        if (status) {
            filter.where.status = 1;
        }
        
        let url = `/api/locations?filter=${encodeURIComponent(JSON.stringify(filter))}`;
        
        return this.http.get(AppService.getApiUrl() + url).pipe(map((res : any) => {
            const data = res.Data;
            return data.filter(item => item.photo.length);
        }));
    }

    getLocationDetail(locationId) {
        const filter = {
            include : [
                'customer',
                {
                    relation: 'photo',
                    scope: {
                        limit: 50,
                        skip: 0,
                        include : 'customer'
                    }
                }
            ]
        }
        
        return this.http.get(LocationService.locationAPI + `${locationId}?filter=${encodeURIComponent(JSON.stringify(filter))}`);
    }
}
